let Utils = {}

Utils.parseTime = (datetime, format) => {
    let output = ''
    const months =['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

    for (let i=0; i<format.length; i++) {
        let letter = format[i]

        switch (letter) {
            case 'h':
                output += datetime.getHours()
                break
            case 'm':
                let m = datetime.getMinutes()
                output += (m<10?'0':'') + m
                break
            case 's':
                output += datetime.getSeconds()
                break
            case 'Y':
                output += datetime.getFullYear()
                break
            case 'M':
                output += months[datetime.getMonth()]
                break
            case 'D':
                output += datetime.getDate()
                break
            default:
                output += letter
        }
    }

    return output
}

Utils.parseTimeDiff = (older_time, newer_time = Date.now()) => {
    var elapsed = (newer_time-older_time) // in milliseconds

    var elapsed_minutes = Math.floor(elapsed/(1000*60))
    var elapsed_hours = Math.floor(elapsed/(1000*60*60))
    var elapsed_days = Math.floor(elapsed/(1000*60*60*24))
    var elapsed_weeks = Math.floor(elapsed/(1000*60*60*24*7))
    var elapsed_months = Math.floor(elapsed/(1000*60*60*24*31))
    var elapsed_years = Math.floor(elapsed/(1000*60*60*24*365))

    var elapsed_str = ''
    if (elapsed_years>0) {
        elapsed_str = elapsed_years + ` year${elapsed_years===1?'':'s'}`
    } else {
        if (elapsed_months>0) {
            elapsed_str = elapsed_months + ` month${elapsed_months===1?'':'s'}`
        } else {
            if (elapsed_weeks>0) {
                elapsed_str = elapsed_weeks + ` week${elapsed_weeks===1?'':'s'}`
            } else {
                if (elapsed_days>0) {
                    elapsed_str = elapsed_days + ` day${elapsed_days===1?'':'s'}`
                } else {
                    if (elapsed_hours>0) {
                        elapsed_str = elapsed_hours + ` hour${elapsed_hours===1?'':'s'}`
                    } else {
                        if (elapsed_minutes>0) {
                            elapsed_str = elapsed_minutes + ` minute${elapsed_minutes===1?'':'s'}`
                        } else {
                            elapsed_str = 'few seconds'
                        }
                    }
                }
            }
        }
    }

    elapsed_str += ' ago'

    return elapsed_str
}

Utils.parseAmount = (num) => {
    if (num !== undefined && num !== null && typeof num === 'number')
        {
            var str = ''
            if (num > 10000000) {
                str = Math.floor(num/1000000) + 'M'
            } else {
                if (num > 1000000) {
                    str = (num/1000000).toFixed(1) + 'M'
                // } else {
                //     if (num > 10000) {
                //         str = Math.floor(num/1000) + 'K'
                    } else {
                        if (num > 1000) {
                            str = (num/1000).toFixed(1) + 'K'
                        } else {
                            str = num.toString()
                        }
                    }
                }
            // }
        return str
        } else {
            return 'N/A'
        }
}

Utils.parseMentions = (content) => {
    return content.split(/(@[\_\.\w]+\w)/gi).map(
        part => {
            if (part.match(/@[\_\.\w]+\w/i)) {
                return {
                    isUser: true,
                    val: part.substring(1)
                }
            }
            return {
                val: part
            }
        }
    )
}

Utils.parseLinks = (content) => {

    // let s = content.split(/(\[(.*?)\])(\((.*?)\))/gim)
    // console.log(s)
    // return content

    // return content.split(/[\]\[]/gi).map(
    //     (part, id) => {
    //         if (id%2==1) {
    //             return <a key={part} href={part} rel="noopener">{part}</a>
    //         }
    //         return part
    //     }
    // )

    return content.split(/(\[.*\])/gi).map(
        part => {
            if (part.match(/\[.*\]/i)) {
                return {
                    isLink: true,
                    val: part.substring(1,part.length-1)
                }
            } else {
                return {
                    val: part
                }
            }
        }
    )
}

Utils.parseFileSize = (cnt) => {
    if (isNaN(cnt)) {
        return '0'
    }
    let kbs = Math.floor(cnt/1024)
    let mbs = Math.floor(cnt/(1024*1024))

    if (mbs>0) {
        return `${(cnt/(1024*1024)).toFixed(1)} MB`
    } else {
        return `${kbs} KB`
    }
}

export default Utils


// WEBPACK FOOTER //
// ./src/components/Utils.js